import { noop } from 'lodash';

import React, { Fragment, PropsWithChildren } from 'react';

import {
  Button as ButtonDS,
  Link as ZinniaLink,
  Spinner,
} from '@zapier/design-system';

type Props = {
  href?: string;
  isDisabled?: boolean;
  isWorking?: boolean;
  onClick?: () => void;
  target?: string;
};

const defaultProps = {
  href: undefined,
  isDisabled: false,
  isWorking: false,
  onClick: noop,
  target: undefined,
};

function Button(props: PropsWithChildren<Props>) {
  const {
    href = defaultProps.href,
    isDisabled = defaultProps.isDisabled,
    isWorking = defaultProps.isWorking,
    children,
    onClick = defaultProps.onClick,
    target = defaultProps.target,
  } = props;

  if (href) {
    return (
      <Fragment>
        <ZinniaLink
          aria-label="submit"
          href={href}
          onPress={onClick}
          target={target}
          variant="primary"
        >
          {isWorking ? <Spinner /> : children}
        </ZinniaLink>
      </Fragment>
    );
  }

  return (
    <ButtonDS aria-label="submit" isDisabled={isDisabled} onPress={onClick}>
      {isWorking ? <Spinner /> : children}
    </ButtonDS>
  );
}

export default Button;
